import cookies from 'js-cookie';

/**
 * Registers a cookie on page opening (to store the initial product ID).
 *
 * @param {number} mainProductId
 */
export default ({ mainProductId }) => {
    cookies.set('checkout_source', `${mainProductId},checkout_page_UNIVERAL`);
}
